import React from 'react'
import { useGameStore } from '../../state/gameStore'
import { appBus } from '../../../app/app-events'

const OptimalSolutionModal: React.FC = () => {
  const { activeModal, optimalSolutionModal } = useGameStore((state) => state.ui)
  const hideModal = useGameStore((state) => state.hideModal)

  if (activeModal !== 'optimalSolution' || !optimalSolutionModal) {
    return null
  }

  const handleNewProblem = () => {
    hideModal()
    appBus.emit('reset-game', {})
  }

  return (
    <div className="fixed inset-0 z-50 pointer-events-auto flex items-center justify-center bg-black/75 backdrop-blur-sm px-4">
      <div className="w-full max-w-xl rounded-2xl border border-emerald-400/30 bg-slate-900/95 shadow-2xl shadow-emerald-900/30">
        <div className="px-6 py-5 border-b border-white/10">
          <h2 className="text-2xl font-bold text-emerald-300 text-center">Optimal Integer Solution Found</h2>
          <p className="text-center text-slate-300 text-sm mt-2">
            The LP relaxation is now integer-feasible. No additional cuts are required.
          </p>
        </div>

        <div className="px-6 py-5">
          <div className="grid grid-cols-2 gap-3 text-sm">
            <div className="rounded-lg border border-white/10 bg-slate-800/60 p-3">
              <div className="text-slate-400">Optimal Value</div>
              <div className="text-lg font-mono text-emerald-300">{optimalSolutionModal.optimalValue.toFixed(3)}</div>
            </div>
            <div className="rounded-lg border border-white/10 bg-slate-800/60 p-3">
              <div className="text-slate-400">Cuts Applied</div>
              <div className="text-lg font-mono text-white">{optimalSolutionModal.cutsApplied}</div>
            </div>
            <div className="rounded-lg border border-white/10 bg-slate-800/60 p-3">
              <div className="text-slate-400">Volume Reduction</div>
              <div className="text-lg font-mono text-sky-300">{optimalSolutionModal.volumeReduction.toFixed(1)}%</div>
            </div>
            <div className="rounded-lg border border-white/10 bg-slate-800/60 p-3">
              <div className="text-slate-400">Initial LP Value</div>
              <div className="text-lg font-mono text-slate-100">{optimalSolutionModal.initialObjectiveValue.toFixed(3)}</div>
            </div>
            <div className="rounded-lg border border-white/10 bg-slate-800/60 p-3 col-span-2">
              <div className="text-slate-400">Reference IP Optimal Value</div>
              <div className="text-lg font-mono text-amber-300">{optimalSolutionModal.initialIPOptimalValue.toFixed(3)}</div>
            </div>
          </div>
        </div>

        <div className="px-6 py-5 border-t border-white/10 flex gap-3 justify-end">
          <button
            type="button"
            onClick={hideModal}
            className="px-4 py-2 rounded-md bg-slate-800 hover:bg-slate-700 text-slate-100 text-sm font-semibold transition-colors"
          >
            Continue Exploring
          </button>
          <button
            type="button"
            onClick={handleNewProblem}
            className="px-4 py-2 rounded-md bg-emerald-600 hover:bg-emerald-500 text-white text-sm font-semibold transition-colors"
          >
            New Problem
          </button>
        </div>
      </div>
    </div>
  )
}

export default OptimalSolutionModal
